// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  email: 'info@cghomes.co.uk',
  firebase: {
    apiKey: "AIzaSyBrSiCrHFs7yw1vK1HbA3JacFt6LXOmvV0",
    authDomain: "landmark-829af.firebaseapp.com",
    databaseURL: "https://landmark-829af-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "landmark-829af",
    storageBucket: "landmark-829af.appspot.com",
    messagingSenderId: "63586633543",
    appId: "1:63586633543:web:942f94ecf426e2c37c6e62",
    measurementId: "G-SPNKHMF2GD"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
